import applicationStore from "../../ApplicationStore";
import RestClient from "../../../integration/RestClient";
import { ActionType } from "..";
import {
  OsisRuleQuery,
  OsisRuleState,
  OsisRuleDelete,
} from "../../../integrated-client";

export class BookingCreateManagerV2TableActions {
  public static async fetchData(data: OsisRuleQuery) {
    const response =
      await RestClient.bookingCreateManagerV2.list.apiBookingCreateManagerOsisV2OsisRuleListListPost(
        {
          osisRuleQuery: data,
        }
      );
    applicationStore.dispatch({
      type: ActionType.BOOKING_CREATE_MANAGER_V2_TABLE_DATA_FETCHED,
      data: response,
    });
    return response;
  }

  public static async disableEnableKeys(data: Array<OsisRuleState>) {
    const response =
      await RestClient.bookingCreateManagerV2.list.apiBookingCreateManagerOsisV2OsisRuleListUpdateStateBulkPost(
        {
          osisRuleState: data,
        }
      );
    applicationStore.dispatch({
      type: ActionType.BOOKING_CREATE_MANAGER_V2_TABLE_DATA_KEYS_ENABLED,
      data: response,
    });
    return response;
  }

  public static async deleteKeys(data: Array<OsisRuleDelete>) {
    const response =
      await RestClient.bookingCreateManagerV2.list.apiBookingCreateManagerOsisV2OsisRuleListDeleteRuleBulkDelete(
        {
          osisRuleDelete: data,
        }
      );
    applicationStore.dispatch({
      type: ActionType.BOOKING_CREATE_MANAGER_V2_TABLE_DATA_KEYS_DELETED,
      data: response,
    });
    return response;
  }

  // NEW: bulk update OSI text across multiple selected rules
  public static async bulkUpdateOsis(ids: Array<string>, osiTexts: Array<string>) {
    const response =
      await RestClient.bookingCreateManagerV2.list.apiBookingCreateManagerOsisV2OsisRuleListBulkUpdateOsisPost(
        { osisRuleBulkUpdateRequest: { ids, osis: osiTexts } }
      );
    applicationStore.dispatch({
      type: ActionType.BOOKING_CREATE_MANAGER_V2_TABLE_DATA_UPDATED,
      data: response,
    });
    return response;
  }
}
